// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mtER","tabsBox":"styles_tabsBox__V4CLK","createButton":"styles_createButton__JCpB1"};